
export default {

  MQTT_BROKER_URL: 'wss://multipoint.agrilog.jp:8084/mqtt',

  users: {

    '1800645': {
      boxes: {
        '親': {
          boxID: 2625,
          deviceID: 'LFFA0'
        },
        '①': {
          boxID: 99001,
          deviceID: 'L1000'
        },
        '②': {
          boxID: 99002,
          deviceID: 'L1001'
        },
        '③': {
          boxID: 98002,
          deviceID: 'L101B'
        },
        '④': {
          boxID: 99004,
          deviceID: 'L1003'
        },
        '⑤': {
          boxID: 99005,
          deviceID: 'L1004'
        },
        '⑥': {
          boxID: 99006,
          deviceID: 'L1005'
        },
        '⑦': {
          boxID: 99007,
          deviceID: 'L1006'
        },
        '⑧': {
          boxID: 99008,
          deviceID: 'L1007'
        }
      }
    },

    '2401717': {
      boxes: {
        '親': {
          boxID: 2509,
          deviceID: 'L0004'
        },
        '①': {
          boxID: 99009,
          deviceID: 'L100A'
        },
        '②': {
          boxID: 99010,
          deviceID: 'L100B'
        },
        '③': {
          boxID: 99011,
          deviceID: 'L100C'
        },
        '④': {
          boxID: 99012,
          deviceID: 'L100D'
        },
        '⑤': {
          boxID: 99013,
          deviceID: 'L100E'
        },
        '⑥': {
          boxID: 99014,
          deviceID: 'L100F'
        },
        '⑦': {
          boxID: 99015,
          deviceID: 'L1010'
        },
        '⑧': {
          boxID: 99016,
          deviceID: 'L1011'
        }
      }
    },

    '2401718': {
      boxes: {
        '親': {
          boxID: 2510,
          deviceID: 'L0005'
        },
        '①': {
          boxID: 99017,
          deviceID: 'L1012'
        },
        '②': {
          boxID: 99018,
          deviceID: 'L1013'
        },
        '③': {
          boxID: 99019,
          deviceID: 'L1014'
        },
        '④': {
          boxID: 99020,
          deviceID: 'L1015'
        },
        '⑤': {
          boxID: 99021,
          deviceID: 'L1016'
        },
        '⑥': {
          boxID: 99022,
          deviceID: 'L1017'
        },
        '⑦': {
          boxID: 99023,
          deviceID: 'L1018'
        },
        '⑧': {
          boxID: 99024,
          deviceID: 'L1019'
        }
      }
    },

    '2501777': {
      boxes: {
        '親': {
          boxID: 3064,
          deviceID: 'L001C'
        },
        '①': {
          boxID: 98003,
          deviceID: 'L101C'
        }
      }
    },

    '2501807': {
      boxes: {
        '親': {
          boxID: 2968,
          deviceID: 'L0025'
        },
        '①': {
          boxID: 98001,
          deviceID: 'L101A'
        },
        '②': {
          boxID: 99026,
          deviceID: 'L1032'
        },
        '③': {
          boxID: 99027,
          deviceID: 'L1033'
        },
        '④': {
          boxID: 99028,
          deviceID: 'L1034'
        },
        '⑤': {
          boxID: 99029,
          deviceID: 'L1035'
        },
        '⑥': {
          boxID: 99030,
          deviceID: 'L1036'
        },
        '⑦': {
          boxID: 99031,
          deviceID: 'L1037'
        },
        '⑧': {
          boxID: 99032,
          deviceID: 'L1038'
        }
      }
    },

    '2401675': {
      boxes: {
        '親': {
          boxID: 2508,
          deviceID: 'LFFA6'
        },
        '①': {
          boxID: 99101,
          deviceID: 'L1008'
        },
        '②': {
          boxID: 99102,
          deviceID: 'L1009'
        },
        '③': {
          boxID: 99103,
          deviceID: 'LFF81'
        },
        '④': {
          boxID: 99104,
          deviceID: 'LFF82'
        },
        '⑤': {
          boxID: 99105,
          deviceID: 'LFF0A'
        },
        '⑥': {
          boxID: 99106,
          deviceID: 'LFF0B'
        },
        '⑦': {
          boxID: 99107,
          deviceID: 'LFF0C'
        },
        '⑧': {
          boxID: 99108,
          deviceID: 'LFF0D'
        }
      }
    },

    'h-igeta': {
      boxes: {
        '親': {
          boxID: 576,
          deviceID: 'L0027'
        },
        '①': {
          boxID: 98004,
          deviceID: 'L1039'
        }
      }
    },

    '1600098': {
      boxes: {
        '親': {
          boxID: 571,
          deviceID: 'L0027'
        },
        '①': {
          boxID: 98004,
          deviceID: 'L1039'
        }
      }
    }

  }

}
